import { WarrantyType } from "Store/findVehicle/interfaces";

export enum WarrantyStatus {
  ACTIVE = "A",
  UNINSURED = "U",
  NOT_MANDATORY = "I",
}

export interface Vehicle {
  readonly brand: string;
  readonly model: string;
  readonly regNumber: string;
  readonly registrationYear: number;

  // model type... 😱
  readonly displayName: string;

  readonly warrantyStatus: WarrantyStatus;
}

export interface DetailedVehicle extends Vehicle {
  readonly kw: number;
  readonly volume: number;
  readonly configurationId: any;

  readonly tfaCode: string;
  readonly leasing?: boolean;
  readonly warrantyType: WarrantyType;
  readonly canBeBoughtOnline: boolean;
  readonly guaranteeOwnerId?: string;
  readonly companyCode?: number;
  readonly companyName?: string;
}

export interface RegisteredVehicleState {
  current: Array<DetailedVehicle | Vehicle> | null;
  isLoading: boolean;
  error: unknown;
}
